import { useCallback, useEffect } from "react";

interface UseKeyPressActionProps {
  key: string | string[];
  callback: (event: KeyboardEvent) => void;
  targetEl?: HTMLElement | null;
}

export default function useKeyPressAction({
  callback,
  key,
  targetEl
}: UseKeyPressActionProps) {
  const handleKeyPress = useCallback(
    (e: KeyboardEvent) => {
      const isFocusedInsideTarget = targetEl ? targetEl.contains(document.activeElement) : true;
      const keyMatches = Array.isArray(key) ? key.includes(e.key) : e.key === key;

      if (keyMatches && isFocusedInsideTarget) {
        callback(e);
      }
    },
    [callback, key, targetEl],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);

    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [handleKeyPress]);
}
